import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import {
  V3AppsContext,
  V3SelectedAppContext,
} from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';
import MultiplePortalAppSideBar from './MultiplePortalAppSidebar';
import ProductAppSidebar from './ProductAppSidebar';
import SidebarDiv from '../../../Common/SideBarDiv';

const ProductSideBar = () => {
  const { productSlug } = useParams<{
    productSlug: string;
  }>();
  const { availableProducts, availableProductApps } = useContext(V3AppsContext);

  const selectedProduct = useMemo(() => {
    return availableProducts.find((app) => app.urlSlug === productSlug);
  }, [availableProducts, productSlug]);

  const selectedProductApp = useMemo(() => {
    if (!selectedProduct) {
      return undefined;
    }

    const subAppsThisUserHasAccessTo = availableProductApps.filter((app) =>
      selectedProduct.appIds.includes(app.id),
    );
    if (subAppsThisUserHasAccessTo.length === 1) {
      return subAppsThisUserHasAccessTo[0];
    }

    return undefined;
  }, [availableProductApps, selectedProduct]);

  if (!selectedProduct) {
    return null;
  }

  if (selectedProductApp) {
    return (
      <V3SelectedAppContext.Provider
        value={{ selectedProduct, selectedProductApp }}
      >
        <SidebarDiv>
          <ProductAppSidebar />
        </SidebarDiv>
      </V3SelectedAppContext.Provider>
    );
  }

  if (selectedProduct.appIds.length === 0) {
    return null;
  }

  return (
    <SidebarDiv>
      <MultiplePortalAppSideBar product={selectedProduct} />
    </SidebarDiv>
  );
};

export default ProductSideBar;
